/**
 * PURPOSE:
 *   Aislar consumos HTTP de configuración de categoría para evitar axios dentro de cards.
 *
 * RESPONSIBILITIES:
 *   - Obtener config_category por idevent/idsport.
 *   - Actualizar únicamente la configuración de tabs públicos.
 *
 * COLLABORATORS:
 *   - src/components/Cards/CardConfiguration/CardConfigPublicTabs/CardConfigPublicTabs.jsx
 *   - src/config/config.js
 *
 * ROUTE:
 *   src/services/configCategoryService.js
 */

import axios from "axios";
import API_BASE_URL from "../config/config.js";

export const getConfigCategory = async ({ idevent, idsport }) => {
  const response = await axios.post(`${API_BASE_URL}/config_category`, {
    idevent: Number(idevent),
    idsport: Number(idsport),
  });

  return response.data;
};

export const updateConfigCategoryPublicTabs = async ({
  idevent,
  idsport,
  tabs_config_publico,
  defaultTabLinkPublico,
}) => {
  const payload = {
    idevent: Number(idevent),
    idsport: Number(idsport),
    tabs_config_publico,
  };

  if (defaultTabLinkPublico !== undefined && defaultTabLinkPublico !== null) {
    payload.defaultTabLinkPublico = Number(defaultTabLinkPublico);
  }

  const response = await axios.patch(
    `${API_BASE_URL}/configcategory/public-tabs`,
    payload
  );

  return response.data;
};
